import EntryPoint from 'Engine/EntryPoint';
import { getRandom } from 'Engine/utils/getRandom';

export default class BonusLabelsGenerator {
  constructor() {

    this.totalWeight = EntryPoint.configData.reels.bonusLabelsWeights.reduce((res, w) => res + w, 0);

    this.labelWeights = [];
    for (let i = 0; i < EntryPoint.configData.reels.bonusLabelsWeights.length; i++) {
      this.labelWeights.push(EntryPoint.configData.reels.bonusLabelsWeights.reduce((res, weight, index) => {
        if (index < i) return res;
        return res + weight;
      }, 0));
    }

  }

  setLabel(symbol) {
    symbol.setValue(this.getLabel());
  }

  getLabel() {
    const randomWeight = getRandom(1, this.totalWeight);
    const index = this.labelWeights.findIndex((weight, i) => {
      let match = randomWeight <= weight;

      if (i < this.labelWeights.length - 1) {
        match = match && randomWeight > this.labelWeights[i + 1];
      }

      return match;
    });

    return EntryPoint.GameModel.availableBonusWinLabels[index];
  }
}
